import { Box } from 'native-base';
import React, { Fragment } from 'react';

export const useMessage = () => {
  const formatText = (text: string) => {
    return text
      .split('\n')
      .map((line, index) => (
        <Fragment key={index}>
          {line.split('**').map((chunk, i) => (i % 2 === 1 ? <Box key={i}>{chunk}</Box> : chunk))}
        </Fragment>
      ));
  };

  return { formatText };
};
